import { styled } from 'styled-components'
import { Student } from '../libs/student-service'
import { Class } from '../libs/login-service'
import { Batch } from '../libs/batch-service'

interface Props {
    student: Student
    selectedClass?: Class
    batch?: Batch
    onBatchChange?: (batchId: number) => void
}

const Wrapper = styled.div`
    display: flex;
    gap: 30px;
    margin: 0 30px;
    border-bottom: 1px solid #e5e6eb;
    align-items: center;
    justify-content: space-between;
`

const StudentText = styled.div`
    padding: 10px 0;
`

const SelectWrapper = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`

const SelectLabel = styled.label`
    font-size: 14px;
    font-weight: 600;
    color: #333;
`

const SelectDropdown = styled.select`
    padding: 8px 12px;
    border: 1px solid #e5e6eb;
    border-radius: 4px;
    font-size: 14px;
    color: #333;
    background-color: #ffffff;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        border-color: #31c690;
    }

    &:focus {
        outline: none;
        border-color: #31c690;
        box-shadow: 0 0 0 2px rgba(49, 198, 144, 0.1);
    }
`

export default function StudentInfo({
    student,
    selectedClass,
    batch,
    onBatchChange,
}: Props) {
    return (
        <Wrapper>
            <div>
                <StudentText>
                    {student.first_name} {student.last_name}
                </StudentText>
                <StudentText>Student ID: {student.id}</StudentText>
            </div>
            {selectedClass && onBatchChange && (
                <SelectWrapper>
                    <SelectLabel>Batch:</SelectLabel>
                    <SelectDropdown
                        value={batch?.id || ''}
                        onChange={(e) => onBatchChange(Number(e.target.value))}
                    >
                        {selectedClass.batches.map((b) => (
                            <option key={b.id} value={b.id}>
                                {b.name}
                            </option>
                        ))}
                    </SelectDropdown>
                </SelectWrapper>
            )}
        </Wrapper>
    )
}
